import i18n from '@/i18n'

function getValueOutOfGivenKey(key, eventData) {
    try {
        const str = JSON.parse(eventData);
        return str[key];
    } catch (err) {
        return undefined;
    }
}

function getTranslationForEventDescription(eventType) {
  let resultString = 'system_event.objects_in_filters_and_table.eventDescription.';
  if(!eventType) {
    return undefined;
  }
  resultString += eventType;
  //console.log(resultString);
  const translation = i18n.t(resultString);
  if(translation == resultString) {
    return undefined;
  }
  return translation;
}

export default {
    getValueOutOfGivenKey,
    getTranslationForEventDescription
}